export default "<section [innerHTML]=\"data?.content\">\n\n</section>\n";